<template>
  <div :class="$style['pt-user-roles']">
    <pt-page-title title="角色权限">
        <template slot="before-left">
            <!-- <el-button type="primary" @click="andRoles">新建角色</el-button> -->
        </template>
    </pt-page-title>
    <pt-roles-table :tableLabels="tableLabels" :pageSize="pageSize" ref="table">
        <el-table-column label="操作">
             <template slot-scope="scope">
                  <i class="iconfont icon-bianji" @click="editRole(scope.row)"></i>
                  <!-- <i class="iconfont icon-shanchu" @click="deleteRole(scope.row)"></i> -->
              </template>
        </el-table-column>
    </pt-roles-table>
  </div>
</template>

<script>
// 组件class前缀
import { rolesTableLabels } from './roles-options.js'
import ptRolesTable from './pt-roles-table/withData.vue'
const prefixCls = 'pt-user-roles'
export default {
  name: 'pt-user-roles',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptRolesTable
  },
  data () {
    return {
      tableLabels: rolesTableLabels,
      pageSize: 10
    }
  },
  methods: {
    andRoles () {
      this.$router.push('/roles-permissions/roles-form/false/0')
    },
    editRole (row) {
      this.$router.push('/roles-permissions/roles-form/true/' + row.id)
    },
    deleteRole (row) {
      this.$confirm('您确认删除该角色？', '删除角色', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.$emit('rolesDelete', row.id)
      })
    },
    getTableData () {
      this.$refs.table.getTableData()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-user-roles{
  :global
  .icon-bianji{
    margin-right: 10px
  }
}
</style>
